export const columns = [
  {
    field: 'nome',
    headerName: 'Razão Social',
    width: 210,
  },
];
